export type TLanguage = {
  onboarding: {
    CreateAccount: string;
    UseSandbox: string;
    RequestLive: string;
    ActivateLaunch: string;
  };
  createAccount: {
    Heading: string;
    SubHeading: string;
    EmailAlreadyExists: string;
    EmailAddressNote: string;
    BusinessNameNote: string;
    CompanyInfoHeader: string;
    FirstName: string;
    LastName: string;
    EmailAddress: string;
    BusinessName: string;
    Website: string;
    Country: string;
    PhoneNumber: string;
    FirstNameReqErorr: string;
    LastNameReqErorr: string;
    EmailIdReqErorr: string;
    BusinessReqErorr: string;
    WebsiteReqError: string;
    PhoneReqErorr: string;
    OnlyLettersError: string;
    EmailIdInvErorr: string;
    WebsiteInvErorr: string;
    PhoneInvErorr: string;
    Continue: string;
    PrimaryRole:string;
    CompanySize:string;
    RegionOperation:string;
    BuildingApplication:string;
    Custom:string;
    Commercial:string;
    ServeBusiness:string;
    DescripApplication:string;
    IAgree :string;
    EnterStudioId:string;
    StudioIdReqError:string;
    StudioIdInvError:string;
    IAgreeReqError :string;
    GetStarted: string;
    Back:string;
    APITerms:string;
    EnterText:string;
    accountCatagoryReq:string;
    ActivateLaunchSuccessMessage:string;
    ValidURLMessage:string;
    IsValid:string;
    DescriptionNote:string;  
    OtherBusinessReqError:string;
  };
  apiHeader: {
    PublicApi: string;
    Webhooks: string;
  };
};

const language: TLanguage = {
  onboarding: {
    CreateAccount: "Create Your Account",
    UseSandbox: "Use Free Sandbox",
    RequestLive: "Request to Go Live",
    ActivateLaunch: "Activate & Launch",
  },
  createAccount: {
    accountCatagoryReq:"*Required",
    Heading: "We're glad you're here!",
    SubHeading:
      "Tell us a little about yourself to get started and for free access to our Sandbox environment.",
    EmailAlreadyExists:
      "This email address is already registered. Please choose a different email address.",
    EmailAddressNote:
      "(This email address will be used to send you the important messages.)",
    BusinessNameNote: "(You can not change your Business Name later.)",
    CompanyInfoHeader:
      "Tell us a little more about yourself for a better experience.",   
    FirstName: "First Name*",
    LastName: "Last Name*",
    EmailAddress: "Email Address*",
    BusinessName: "Business Name*",
    Website: "Website*",
    Country: "Country",
    PhoneNumber: "Phone Number*",
    FirstNameReqErorr: "*First name is required",
    LastNameReqErorr: "*Last name is required.",
    EmailIdReqErorr: "*Email Id is required.",
    BusinessReqErorr: "*Business name is required.",
    WebsiteReqError: "Website link required.",
    PhoneReqErorr: "*Phone number is required.",
    OnlyLettersError: "*Must Contain only characters.",
    EmailIdInvErorr: "*Invalid email id.",
    WebsiteInvErorr: "*Invalid URL.",
    PhoneInvErorr: "Invalid Phone Number.",
    Continue: "Continue",
    PrimaryRole: "Primary Role",
    CompanySize: "Company Size",
    RegionOperation: "Region of Operation",
    BuildingApplication: "I am building this application for*",
    Custom: "A specific business using Mindbody (Custom)",
    Commercial: "Multiple businesses using Mindbody (Commercial)",
    ServeBusiness:
      "I'm building this application to serve the following business/es",
    DescripApplication:
      "Give us a brief description about the application you're building",
    IAgree: "I agree to Mindbody",
    EnterStudioId: "Enter Studio ID",
    StudioIdReqError: "*Please enter studio id",
    StudioIdInvError: "*Please enter valid studio id",
    IAgreeReqError: "Please select Mindbody API Terms of Use.",
    GetStarted: "GetStarted",
    Back: "Back",
    APITerms: "API Terms of Use*",
    EnterText: "Enter your text here...",
    ActivateLaunchSuccessMessage:"API Billing account created successfully!",
    ValidURLMessage:"must be valid url.",
    IsValid:"is invalid.",
    DescriptionNote:"(Your business description will be featured on our partner portal.)",
    OtherBusinessReqError:"Other business required."
  },
  apiHeader: {
    PublicApi: "PUBLIC API",
    Webhooks: "WEBHOOKS API",
  },
};

export default language;
